import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M3 6.234a6.725 6.725 0 0 1 2.5-.484A6.746 6.746 0 0 1 12.225 12H17c.55 0 1-.45 1-1V3.5H3v2.734zM13 5h3v1.5h-3V5zm4-5H4c-.55 0-1 .45-1 1v1h15V1c0-.55-.45-1-1-1zM9.555 10.181l.418-.986-1.168-1.168-.986.418a4.713 4.713 0 0 0-1.092-.453L6.326 7H4.674l-.401.992a4.713 4.713 0 0 0-1.092.453l-.986-.418-1.168 1.168.418.986a4.627 4.627 0 0 0-.453 1.092L0 11.674v1.652l.992.401c.103.378.254.744.453 1.092l-.418.986 1.168 1.168.986-.418c.348.199.714.351 1.092.453l.401.992h1.652l.401-.992a4.67 4.67 0 0 0 1.092-.453l.986.418 1.168-1.168-.418-.986c.199-.348.351-.714.453-1.092l.992-.401v-1.652l-.992-.401a4.713 4.713 0 0 0-.453-1.092zM5.5 15a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
  </svg>
);

export default SvgComponent;
